import { initBrowserRum } from '@smg-real-estate/browser-rum';

export function initDatadogRUM(): void {
  const platform = import.meta.env.VUE_APP_PLATFORM_THEME;

  if (!platform) {
    return;
  }

  initBrowserRum({
    applicationId: import.meta.env.VUE_APP_DATADOG_RUM_APPLICATION_ID,
    clientToken: import.meta.env.VUE_APP_DATADOG_RUM_CLIENT_TOKEN,
    service: `${platform.toLowerCase()}-agency-directory-vue`,
    env: import.meta.env.VUE_APP_ENVIRONMENT,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 10,
    // As there is only searchbar input in the app, the default privacy level is set to allow
    defaultPrivacyLevel: 'allow',
    version: import.meta.env.VUE_COMMIT_SHA,

    // only initialize in production
    enabled: import.meta.env.VUE_APP_ENVIRONMENT === 'prod',
    // enables tracking based on user consent
    trackingConsentEnabled: true,
    // add custom attributes to global context
    customAttributes: {
      platform: import.meta.env.VUE_APP_PLATFORM_THEME,
    },
  });
}
